import React from 'react';
import { Button } from 'antd';
import Utils from '@/utils';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ProdLogo } from '@/assets/icons/prod-logo.svg';
import { ReactComponent as AudioIcon } from '@/assets/icons/audio-bold.svg';
import { ReactComponent as FileFailedIcon } from '@/assets/icons/file-failed.svg';
import sendGaEvent from '@/ga';
import '@/assets/audioExtractor.less';

const AudioExtractorCompleteRender = ({ audioExtractorFileAfter, handleDownload, handleSubmitAgain, advertiseConfig, openAdvertiseDialog }) => {
  const { t } = useTranslation(['audioExtractor', 'common', 'advertise']);
  const openDialog = () => {
    sendGaEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_UnderExtractedSuccessfullyClick',
    });
    advertiseConfig({
      isShowBtn: false,
      isShowHeader: false,
      headerObj: '',
      titleIndex: 2,
      imgIndex: 3,
      source: 'extractSuccess',
    });
    openAdvertiseDialog(true);
    sendGaEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_UnderExtractedSuccessfullyShow',
    });
  };
  return (
    <div className='workplace-complete'>
      <div className='point-con'>
        <div className='workplace-complete-title'>
          <div>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              {audioExtractorFileAfter.status === 'success' ? t('Extracted Successfully') : t('Extraction Failed')}
            </div>
            {Utils.getSystemType() != 'other' ? (
              <span
                onClick={() => openDialog()}
                style={{
                  fontSize: 16,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                <ProdLogo /> {t('advertise:ExtractingAudioInThousandsSites')}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      <div className='point-con'>
        {audioExtractorFileAfter && audioExtractorFileAfter.status === 'success' ? (
          <div>
            <div className='success-list'>
              <div className='item' key={audioExtractorFileAfter.guid}>
                <div className='info'>
                  <AudioIcon />
                  <span>{Utils.omissionString(audioExtractorFileAfter.name, 5, 7)}</span>
                </div>
                <span>{(audioExtractorFileAfter.size / 1024 / 1024).toFixed(2)}MB</span>
              </div>
            </div>
            <div className='btn-groups'>
              <Button type='primary' onClick={handleDownload}>
                <span>{t('common:Download')}</span>
              </Button>
              <Button
                type='primary'
                ghost
                onClick={() => {
                  window.open(window.location.href);
                }}
              >
                {t('Extract New')}
              </Button>
            </div>
          </div>
        ) : audioExtractorFileAfter.status === 'failed' ? (
          <div>
            <div className='failed-list'>
              <div className='item' key={audioExtractorFileAfter.guid}>
                <div className='info'>
                  <FileFailedIcon />
                  <span>{Utils.omissionString(audioExtractorFileAfter.name, 5, 7)}</span>
                </div>
                <span>{(audioExtractorFileAfter.size / 1024 / 1024).toFixed(2)}MB</span>
                <div className='del-tip'>
                  <span>{t('common:Failed')}</span>
                </div>
              </div>
            </div>
            <div className='btn-groups'>
              <Button type='primary' onClick={handleSubmitAgain}>
                {t('common:Try Again')}
              </Button>
              <Button
                type='primary'
                ghost
                onClick={() => {
                  window.open(window.location.href);
                }}
              >
                {t('Extract New')}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AudioExtractorCompleteRender;
